"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateDoiPageRequestStatus = exports.getFetchDoiPagesRequestStatus = exports.getDoiPages = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getDoiPages = function getDoiPages(state) {
  return state.modules.marketing.email.entities.doiPages;
};

exports.getDoiPages = getDoiPages;
var getFetchDoiPagesRequestStatus = (0, _getRequestStatus.default)(_actions.DoiPagesActionTypes.FETCH_DOI_PAGES);
exports.getFetchDoiPagesRequestStatus = getFetchDoiPagesRequestStatus;
var getUpdateDoiPageRequestStatus = (0, _getRequestStatus.default)(_actions.DoiPagesActionTypes.UPDATE_DOI_PAGE);
exports.getUpdateDoiPageRequestStatus = getUpdateDoiPageRequestStatus;